import { User } from "@/models/lib";

const userState = {
    state: {
        token: localStorage.getItem("config_token") || "",
        dataToken: localStorage.getItem("config_token") || "",
        epmToken: localStorage.getItem("data_token") || "",
        user: JSON.parse(localStorage.getItem("currentUser")) || null
    },
    getters: {
    /**
     * @deprecated 
     */
        getCurrentUser(state) {
            console.error("Vuex: 'getCurrentUser' is deprecated, use 'getUser' instead");
            return new User(state.user);
        },
        getUser(state) {
            return new User(state.user);
        },
        getToken(state) {
            return state.token;
        },
        hasTokens(state) {
            return true;
            const { token, dataToken } = state;
            return !!dataToken && !!token;
        },
        isUserStaff: state => {
            return (state.user) ? state.user.is_staff : false;
        },
        isSuperUser: state => {
            return state.user ? state.user.is_superuser : false;
        },
        isInvestor: state => {
            if (state.user) {
                return state.user.is_investor || false;
            }
            return false;
        }
    },
    mutations: {
        setToken(state, token) {
            state.token = token;
        },
        setDataToken(state, token) {
            state.dataToken = token;
        },
        setEPMToken(state, token) {
            state.epmToken = token;
        },
        setUser(state, payload) {
            state.user = payload;
        },
        logout(state) {
            state.token = "";
            state.dataToken = "";
            state.user = null;
        }
    },
    actions: {
        setToken({ commit }, token) {
            if (token) {
                commit("setToken", token);
            }
        },
        setDataToken({ commit }, token) {
            if (token) {
                commit("setDataToken", token);
            }
        },
        setEPMToken({ commit }, token) {
            if (token) {
                commit("setEPMToken", token);
            }
        },
        setUser({ commit }, payload) {
            if (payload) {
                commit("setUser", payload);
            }
        },
        logout({ commit }) {
            commit("logout");
        }

    },
};




export default userState;